// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 24577) return "static/chunks/df56de66-ec5c608d9eeb6fef.js";
	// return url for filenames based on template
	return "static/chunks/" + "d9a6f71e" + "." + "34dc9e09dc77c5f3" + ".js";
};